import React from "react";

const Sponsoring = () => {
    return (
        <div className='p-5 mx-5 bg-gradient-to-b from-[#e2ce9d] to-[#f9b866]'>
             <div className='max-w-4xl mx-auto'>
        <div className='mx-auto mt-5 text-center text-2xl font-[Bold] text-[#503854]'>
NASI SPONSORZY </div>
<div className='p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded' />
        <div className='mx-auto mt-5 text-center font-[Light]'>

        AKCJE WSPIERA NASZ PARTNER SKLEP WUJO POZNAŃ SPRAWDŹCIE CO MA WAM DO PRZEKAZANIA. </div>
        <div className="flex-wrap mx-auto px-20 my-10 max-w-full mt-5 flex justify-center">
        <img src={`${process.env.REACT_APP_API_DOMAIN}/images/wujo_logo_violet.png`} />

        </div>

        <div className='mx-auto my-5 font-[Bold] text-[#503854]'>
        WITAMY W SKLEPIE WUJO POZNAŃ, PRODUCENTA, BEZPOŚREDNIEGO IMPORTERA, EKSPORTERA ORAZ DYSTRYBUTORA AKCESORIÓW I GADŻETÓW DLA PALACZY. W NASZEJ OFERCIE ZNAJDZIECIE SZEROKI ASORTYMENT SHISH, FAJEK WODNYCH, BONG, AKCESORIÓW DLA PALACZY ORAZ WIELE DROBIAZGÓW, KTÓRE PRZYDADZĄ SIĘ MIŁOŚNIKOM FAJKI WODNEJ I NIE TYLKO. ZAPRASZAMY DO NASZEGO SKLEPU „NA DEPTAKU” UL. PÓŁWIEJSKA 27 W POZNANIU ORAZ ONLINE NA WUJOPOZNAN.PL.</div>
        <div className='p-1 mb-5 w-full mt-5 drop-shadow-xl bg-[#503854] rounded' />
        </div>
        </div>
    )
}

export default Sponsoring;